<template>
  <el-row>
    <el-col :span="24">
      <div style="display: flex; justify-content: center; align-items: flex-end; height: 24rem; padding: 5rem 0 3rem 0; background: url('../../../static/images/AboutUs/AboutUs_bg.png') 0% 0% / cover">
        <div style="display: flex; justify-content: center; align-items: flex-end; width: 1108px; font-size: 2rem; font-weight: 700; color: #fff; line-height: 3rem">
<!--          依托自身在BIM领域雄厚的技术实力， <br>-->
          致力于数据层面为新工程助力<br>
          为客户创造长期价值
        </div>
      </div>
    </el-col>
    <el-col :span="24">
      <div style="display: flex; justify-content: center; align-items: center; padding: 5rem 0 7rem 0">
        <div style="display: flex; justify-content: center; align-items: flex-start; flex-flow: column; width: 1108px">
          <span style="font-size: 1rem; font-weight: 700; color: #222; margin-bottom: 1.5rem">企业简介</span>
          <div style="font-size: 1rem; font-weight: 400; color: #666; line-height: 1.5rem; text-align: left; margin-bottom: 5rem">
            上海彼栈数据技术有限公司（BIM Stacks Data Tech. CO., LTD.）顺应工程建筑信息化的大趋势，依托自身在BIM领域扎实的技术实力，扎根工程具体业务应用，为BIM落地提供高效的解决方案，致力于从数据层面为新工程助力。公司核心技术骨干来自于欧特克、鹰图、IBM等全球知名信息化提供商，多年的软件产品化思维，与工程业务的专业领域知识和经验的碰撞融合，产生了团队特有的复合化的特征，搭配上多年市场一线的磨练，赋予了彼栈的本土市场亲和力，公司多元化背景亦造就了团队特有的市场成熟度。 彼栈数据作为工程建筑行业数据服务商，深挖数据价值，服务于工程应用，以数据加强各方沟通与协作，以技术实力和服务做到管理的规范与高效。
          </div>
          <!-- <span style="font-size: 1rem; font-weight: 700; color: #222; margin-bottom: 1.5rem">合作伙伴</span> -->
          <!-- <div>
            <el-image src="../../../static/images/AboutUs/AboutUs_001.png" style="width: 7rem; margin-right: 4rem;"></el-image>
            <el-image src="../../../static/images/AboutUs/AboutUs_002.png" style="width: 7rem"></el-image>
          </div> -->
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
    export default {
        name: "AboutUs",
        data: function () {
          return {
          }
        },
        components: {

        },
        created() {
        },
        mounted() {
          document.body.scrollTop = document.documentElement.scrollTop = 0;
        },
        methods: {

        }
    }
</script>

<style scoped>
  .el-main > .el-row {
    min-width: 1108px;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/AboutUs.vue